package com.shadowings.gero.domain.model

import org.jetbrains.compose.resources.StringResource

data class LessonNode(
    val id: String,
    val title: StringResource,
    val description: StringResource,
    val type: LessonType,
    val stars: Int,
    val trigger: String? = null,
    val chapter: Int,
    val hiero: String = ""
)